import { ReactNode } from 'react';
import s from './Button.module.scss';

export interface IButtonProps {
	children: ReactNode;
	className?: string;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const Button = ({ children, className, onClick }: IButtonProps) => {
	return (
		<button className={`${s.button} ${className}`} onClick={onClick}>
			{children}
			<div className={s.triangle}></div>
		</button>
	);
};
